import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TextLinkProps {
    href: string
    children: ReactNode
    className?: string
    intro?: boolean
}

export const TextLink: FC<TextLinkProps> = ({ href, children, className, intro = false }): ReactNode => {
    return (
        <Link href={href} className={cn('hud group inline-flex items-center gap-2 text-ink', className)}>
            <span className='relative pb-1'>
                {children}

                <span
                    className={cn('absolute inset-x-0 bottom-0 h-px origin-left bg-ink/45 transition-colors duration-300 group-hover:bg-ink', intro && 'intro-underline')}
                    aria-hidden='true'
                />
            </span>

            <ArrowUpRight
                className='size-4 -translate-y-0.5 transition-transform duration-500 ease-instrument group-hover:-translate-y-1 group-hover:translate-x-0.5'
                strokeWidth={1.5}
                aria-hidden='true'
            />
        </Link>
    )
}
